module.exports = __webpack_public_path__ + "static/img/01.456d073.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/samples/300x300/01.jpg
// module id = 2Dyf
// module chunks = 0